import {Checkbox} from 'cdk-radial'
import get from 'lodash/get';
import React from 'react';
import { useUnifyAdminStore } from '../AdminStore';
import { AdminInputWithCustomHelperText } from '../Blocks/AdminInputWithCustomHelperText';
import { t } from 'i18next';

export const DescriptionField = (): JSX.Element => {

  /**
   * Data Store
   */
  const permissions = useUnifyAdminStore(state => state.permissions);
  const sideSheetData = useUnifyAdminStore((state) => state.sideSheetData);
  const showFrenchTranslation = useUnifyAdminStore((state) => state.showFrenchTranslation)
  const setShowFrenchTranslation = useUnifyAdminStore((state) => state.setShowFrenchTranslation)
  const showCanadaEnglishTranslation = useUnifyAdminStore((state) => state.showCanadaEnglishTranslation)
  const setShowCanadaEnglishTranslation = useUnifyAdminStore((state) => state.setShowCanadaEnglishTranslation)
  const sideSheetSubWorkflowData = useUnifyAdminStore(
    (state) => state.sideSheetDataSubWorkflow
  );
  const updateSideSheetData = useUnifyAdminStore(
    (state) => state.updateSideSheetData
  );
  const isWorkflowSideSheetCollapse = useUnifyAdminStore(
    (state) => state.isWorkflowSideSheetCollapse
  );

  const handleUpdateFrCaDescription = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    return (updateSideSheetData({
      fieldName: 'description',
      value: {[event.target.name]: event.target.value, enCA: description.enCA, enUS: description.enUS}
    }));
  }

  const handleUpdateEnCaDescription = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    return (updateSideSheetData({
      fieldName: 'description',
      value: {[event.target.name]: event.target.value, frCA: description.frCA, enUS: description.enUS}
    }));
  }

  const handleUpdateEnDescriptionField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    return updateSideSheetData({
      fieldName: 'description',
      value: {[event.target.name]: event.target.value, frCA:description.frCA, enCA: description.enCA},
    });
  };

  const description = get(
    !isWorkflowSideSheetCollapse ? sideSheetSubWorkflowData : sideSheetData,
    'description'
  );
  return (
    <>
      <AdminInputWithCustomHelperText
        helperLabel={`${description?.enUS?.length || 0}/200`}
        dataTestId="description-input"
        errorMessage="Error message"
        id="description-input"
        inputDivider="left"
        label={t('appsAndWorkflows.description')}
        name="enUS"
        onChange={handleUpdateEnDescriptionField}
        onInputClear={function noRefCheck() {}}
        placeholder={t('appsAndWorkflows.descriptionPlaceholder')}
        maxLength={200}
        value={description?.enUS || ''}
        rows={Math.max(1, Math.ceil((description?.enUS?.length || 0) / 48))}
        isDisabled={permissions?.hasAppReadOnlyPermissions && !permissions?.hasAppSuperAdminPermissions && !permissions.hasAppUpdatePermissions}
      />
      <Checkbox
          checked={showFrenchTranslation}
          dataTestId="show-french-checkbox"
          id="newsletter"
          label={t('appsAndWorkflows.showFrenchDescription')}
          labelPosition="after"
          name="frenchShow"
          onChange={()=>setShowFrenchTranslation(!showFrenchTranslation)}
          size="standard"
      />
      <Checkbox
          checked={showCanadaEnglishTranslation}
          dataTestId="show-canada-english-checkbox"
          id="newsletterCA"
          label={t('appsAndWorkflows.showCanadaEnglishDescription')}
          labelPosition="after"
          name="canadaEnglishShow"
          onChange={()=>setShowCanadaEnglishTranslation(!showCanadaEnglishTranslation)}
          size="standard"
        />
      {
          showFrenchTranslation &&
          <AdminInputWithCustomHelperText
          helperLabel={`${description?.frCA?.length || 0}/350`}
          dataTestId="fr-description-input"
          errorMessage="Error message"
          id="fr-description-input"
          inputDivider="left"
          label={t('appsAndWorkflows.frenchDescription')}
          name="frCA"
          onChange={handleUpdateFrCaDescription}
          onInputClear={function noRefCheck() {}}
          placeholder={t('appsAndWorkflows.frenchDescriptionPlaceholder')}
          maxLength={350}
          value={description?.frCA || ''}
          rows={Math.max(1, Math.ceil((description?.frCA?.length || 0) / 48))}
          isDisabled={permissions?.hasAppReadOnlyPermissions && !permissions?.hasAppSuperAdminPermissions && !permissions.hasAppUpdatePermissions}
          />
      }
       {  
          showCanadaEnglishTranslation &&
          <AdminInputWithCustomHelperText
          helperLabel={`${description?.enCA?.length || 0}/350`}
          dataTestId="enCA-description-input"
          errorMessage="Error message"
          id="enCA-description-input"
          inputDivider="left"
          label={t('appsAndWorkflows.canadaEnglishDescription')}
          name="enCA"
          onChange={handleUpdateEnCaDescription}
          onInputClear={function noRefCheck() {}}
          placeholder={t('appsAndWorkflows.canadaEnglishDescriptionPlaceholder')}
          maxLength={350}
          value={description?.enCA || ''}
          rows={Math.max(1, Math.ceil((description?.enCA?.length || 0) / 48))}
          isDisabled={permissions?.hasAppReadOnlyPermissions && !permissions?.hasAppSuperAdminPermissions && !permissions.hasAppUpdatePermissions}
          />
        }
    </>
  );
};
